// src/components/NotFoundPage.jsx

import React from 'react';
import FuzzyText from './FuzzyText.jsx';

const NotFoundPage = () => {
  return (
    <div style={{
      textAlign: 'center',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <FuzzyText 
        baseIntensity={0.2} 
        hoverIntensity={0.18} 
        enableHover={true}
      >
        404 not found
      </FuzzyText>
      <a href="/" style={{ color: '#61dafb', marginTop: '20px' }}>
        Return to Safety
      </a>
    </div>
  );
};

export default NotFoundPage;
